var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2250_1194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0335 3.26668L10.7335 7.81657C10.8501 8.16657 10.8501 8.5166 10.7335 8.8666C10.6168 9.2166 10.5001 9.56666 10.2668 9.79999L8.05013 12.7167C9.5668 15.8667 12.1335 18.3166 15.2835 19.9499L18.0835 17.85C18.3168 17.6167 18.6668 17.3834 19.0168 17.2667C19.3668 17.15 19.8335 17.15 20.1835 17.2667L24.7335 17.9667C25.3168 18.0833 25.7835 18.3166 26.1335 18.7833C26.4835 19.2499 26.7168 19.7167 26.7168 20.3V24.7332C26.7168 25.3166 26.4835 25.7833 26.1335 26.1333C25.7835 26.4833 25.2001 26.7167 24.7335 26.7167C18.4335 26.7167 12.4835 24.2666 8.05013 19.8333C3.6168 15.4 1.1668 9.4499 1.1668 3.1499C1.1668 2.56657 1.40014 2.09996 1.75014 1.74996C2.10014 1.39996 2.68347 1.16663 3.15013 1.16663H7.58347C8.1668 1.16663 8.75014 1.39996 9.10014 1.74996C9.56681 2.21663 9.91681 2.68335 10.0335 3.26668Z",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2250_1194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "matrix(-1 0 0 1 28 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c37f9ac60cc1721b65518bc34e14f499.svg";
export { ForwardRef as ReactComponent };